// plaid-reducer.ts
import { createSlice, createAction, PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

// State Types
interface PlaidState {
  isConnected?: boolean;
  isLoading?: boolean;
}

// Initial state
const initialState: PlaidState = {
  isConnected: false,
  isLoading: false,
};

// Actions
export const setIsConnected = createAction<PlaidState>("plaid/setIsConnected");

// Async action to check Plaid connection status
export const checkPlaidStatus = createAsyncThunk(
  "plaid/checkStatus",
  async () => {
    const response = await fetch("/api/plaid/status");
    const data = await response.json();
    return data.isConnected;
  },
);

// Reducer
const plaidSlice = createSlice({
  name: "plaid",
  initialState,
  reducers: {
    setIsConnected: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkPlaidStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        checkPlaidStatus.fulfilled,
        (state, action: PayloadAction<boolean>) => {
          state.isLoading = false;
          state.isConnected = action.payload;
        },
      )
      .addCase(checkPlaidStatus.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setIsConnected: setIsConnectedAction } = plaidSlice.actions;
export default plaidSlice.reducer;
